var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header" }, [
    _c(
      "div",
      { staticClass: "centerBar" },
      _vm._l(_vm.navList, function (item, index) {
        return _c(
          "div",
          {
            key: item.name,
            staticClass: "item",
            class: index === _vm.granaryIndex ? "active" : "",
            on: {
              click: function ($event) {
                return _vm.onClick(index)
              },
            },
          },
          [_vm._v(" " + _vm._s(item.name) + " ")]
        )
      }),
      0
    ),
    _c("div", { staticClass: "rightBar" }, [
      _c("span", { staticClass: "date" }, [_vm._v(_vm._s(_vm.nowDate1))]),
      _c("span", { staticClass: "week" }, [_vm._v(_vm._s(_vm.DateToday))]),
      _c("span", { staticClass: "time num" }, [_vm._v(_vm._s(_vm.nowTime))]),
      _c("div", [
        _c("span", { staticClass: "flex cursor" }, [
          _c("img", { attrs: { width: "20px", src: _vm.form.code } }),
          _c("span", [_vm._v(_vm._s(_vm.form.sk_s))]),
          _c("span", [_vm._v(_vm._s(_vm.form.sk_t) + "°C")]),
        ]),
      ]),
      _c(
        "a",
        {
          staticClass: "yyzx",
          attrs: {
            href: _vm.yyurl,
            title: "茂名市荔枝优势产区产业园荔枝产业大数据中心",
          },
        },
        [
          _c("img", {
            attrs: { src: require("images/index/home/yyxt.png"), alt: "" },
          }),
          _c("p", [_vm._v("应用中心")]),
        ]
      ),
    ]),
    _c("a", { staticClass: "click-area", on: { click: _vm.goHome } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }